(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    tabTitles.forEach(tab => {
        tab.addEventListener('click', function() {
            // Remove active class from all tabs and contents
            tabTitles.forEach(t => t.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));

            // Add active class to the clicked tab and corresponding content
            tab.classList.add('active');
            document.getElementById(tab.dataset.tab).classList.add('active');
        });
    });

    // Activate the first tab by default
    if (tabTitles.length > 0) {
        tabTitles[0].click();
    }
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-aside"] && !Shopify.designMode) return;
  try {
    
  const items = document.querySelectorAll(".instagram__item")
  // console.debug(items)
  items.forEach(element => {
    element.addEventListener("click", handleSelectedItem)
  })

  function handleSelectedItem(event) {
    const id = event.target.dataset.itemId
    const currentElement = document.querySelector(".gallery-item-details.is-visible")  
    currentElement.classList.replace("is-visible", "is-hidden")
    const element = document.querySelector(`[data-id='gallery_item_${id}']`)
    element.classList.replace("is-hidden", "is-visible")
    
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-with-description"] && !Shopify.designMode) return;
  try {
    
  const items = document.querySelectorAll(".instagram__item")
  // console.debug(items)
  items.forEach(element => {
    element.addEventListener("click", handleSelectedItem)
  })

  function handleSelectedItem(event) {
    const id = event.target.dataset.itemId
    const currentElement = document.querySelector(".gallery-item-details.is-visible")  
    currentElement.classList.replace("is-visible", "is-hidden")
    const element = document.querySelector(`[data-id='gallery_item_${id}']`)
    element.classList.replace("is-hidden", "is-visible")
    
  }

  } catch(e) { console.error(e); }
})();
})();
